export default {
  "home.heading.default": "ມາລົມກັນ",
  "home.heading.loading": "ກຳລັງເປີດຫ້ອງ...",
  "home.heading.join": "ພ້ອມເຂົ້າແລ້ວບໍ່?",
  "home.heading.joined": "ເຂົ້າແລ້ວ",
  "home.heading.pending": "ລໍຖ້າເຈົ້າຂອງຫ້ອງ",
  "home.body.default": "ສ້າງຫ້ອງ, ສົ່ງລິ້ງ, ແລ້ວມ່ວນເລີຍ.",
  "home.body.loading": "ແປັບໜຶ່ງ, ກຳລັງດຶງຫ້ອງ.",
  "home.body.join": "ເຊັກກ້ອງກັບໄມ, ແລ້ວເຂົ້າເລີຍ.",
  "home.body.joined": "ຫ້ອງເປີດແລ້ວ. ແຊຣ໌ລິ້ງ ຫຼື ລຸຍເລີຍ.",
  "home.body.joined_in_room": "ຢູ່ໃນຫ້ອງແລ້ວ — ລຸຍເລີຍ ຫຼື ແຊຣ໌ລິ້ງ.",
  "home.body.pending": "ຫ້ອງລັອກຢູ່. ດຽວເຈົ້າຂອງຫ້ອງຈະຮັບເຂົ້າ.",
  "home.cta.create": "ສ້າງຫ້ອງ",
  "home.cta.join": "ເຂົ້າຫ້ອງ",
  "home.cta.enter": "ເຂົ້າຫ້ອງ",
  "home.cta.creating": "ກຳລັງສ້າງ...",
  "home.cta.joining": "ກຳລັງເຂົ້າ...",
  "home.cta.opening": "ກຳລັງເປີດ...",
  "home.cta.pending": "ລໍຖ້າຮັບເຂົ້າ...",
  "home.copy_link": "ກັອບປີ້ລິ້ງ",
  "home.copied": "ກັອບປີ້ແລ້ວ!",
  "home.leave": "ອອກຈາກຫ້ອງ",
  "home.back": "ກັບຄືນ",
  "home.no_participants": "ຍັງບໍ່ມີໃຜເທື່ອ",
  "home.join_by_code": "ເຂົ້າດ້ວຍລະຫັດ",
  "home.code_placeholder": "ໃສ່ລະຫັດ",
  "home.name_placeholder": "ຊື່ຂອງເຈົ້າ",
  "home.people_one": "ຄົນ",
  "home.people_other": "ຄົນ",
  "home.marketing.invite.title": "ສ້າງຫ້ອງ,\nແລ້ວແຊຣ໌ລິ້ງ.",
  "home.marketing.invite.body": "ກົດບາດດຽວເລີ່ມເລີຍ. ແຊຣ໌ລິ້ງໃຫ້ໝູ່ແລ້ວໃຜກໍເຂົ້າໄດ້ — ບໍ່ຕ້ອງໂຫຼດແອັບ, ບໍ່ຕ້ອງສະໝັກ.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "ປັບລຸກ\nຕາມໃຈມັກ.",
  "home.marketing.look.body": "ປັບສີ, ໜ້າເນຽນ, ຂອບມືດ — ຫຼື ເບຼີໜ້າໄປເລີຍກໍໄດ້. ກ້ອງເຈົ້າ, ສະຕາຍເຈົ້າ.",
  "home.marketing.host.title": "ພື້ນທີ່ຂອງເຈົ້າ,\nກົດຂອງເຈົ້າ.",
  "home.marketing.host.body": "ລັອກຫ້ອງ, ປິດໄມ, ຫຼື ເຕະອອກເລີຍກໍໄດ້. ເຈົ້າຂອງຫ້ອງຄຸມເອງ.",
  "home.marketing.host.locked": "ຫ້ອງລັອກຢູ່",
  "home.marketing.host.waiting_to_join": "ລໍຖ້າເຂົ້າຫ້ອງ",
  "home.marketing.host.wants_to_join": "ຢາກເຂົ້າຫ້ອງ",
  "home.marketing.anything.title": "ສຳລັບທຸກຢ່າງ, ອີ່ຫຼີ.",
  "home.marketing.anything.body": "ຕິວໜັງສື, ຫຼິ້ນເກມ, ລົມວຽກ, ເບິ່ງໜັງນຳກັນ — ຫຼື ແຄ່ລົມກັນຫຼິ້ນໆ.",
  "home.marketing.use_case.study_group": "📚 ຕິວໜັງສື",
  "home.marketing.use_case.game_night": "🎮 ຫຼິ້ນເກມ",
  "home.marketing.use_case.standup": "💼 ອັບເດດວຽກ",
  "home.marketing.use_case.watch_party": "🍿 ເບິ່ງໜັງນຳກັນ",
  "home.marketing.use_case.catch_up": "☕ ອັບເດດຊີວິດ",
  "home.marketing.use_case.jam_session": "🎸 ຫຼິ້ນດົນຕີ",
  "home.marketing.use_case.book_club": "📖 ລົມເລື່ອງປຶ້ມ",
  "home.marketing.use_case.coworking": "💻 ນັ່ງເຮັດວຽກ",
  "ended.heading": "ຈົບສາຍແລ້ວ",
  "ended.left": "ເຈົ້າອອກຈາກຫ້ອງແລ້ວ.",
  "ended.room_ended": "{title} ຈົບລົງແລ້ວສຳລັບເຈົ້າ.",
  "ended.rejoin": "ເຂົ້າໃໝ່",
  "ended.rejoining": "ກຳລັງເຂົ້າໃໝ່...",
  "ended.home": "ກັບໜ້າຫຼັກ",
  "call.connecting": "ກຳລັງເຊື່ອມຕໍ່",
  "call.waiting": "ລໍຖ້າຄົນອື່ນ",
  "call.invite_code": "ລະຫັດເຊີນ",
  "call.audio_on": "ເປີດສຽງ",
  "call.muted": "ປິດໄມຢູ່",
  "call.listening": "ກຳລັງຟັງ",
  "call.audio_muted": "ປິດສຽງຢູ່",
  "call.speaking": "ກຳລັງເວົ້າ",
  "call.you": "ເຈົ້າ",
  "call.you_label": "ເຈົ້າ",
  "call.you_suffix": "(ເຈົ້າ)",
  "call.chat_placeholder": "ພິມຂໍ້ຄວາມ...",
  "call.guest": "ແຂກ",
  "call.room_fallback": "ຫ້ອງ",
  "call.focus_view": "ມຸມມອງໂຟກັສ",
  "call.grid_view": "ມຸມມອງກຣິດ",
  "call.swap_main_video": "ສະຫຼັບວິດີໂອຫຼັກ",
  "call.open_chat": "ເປີດແຊັດ",
  "call.close_chat": "ປິດແຊັດ",
  "call.leave_room": "ອອກຈາກຫ້ອງ",
  "call.confirm_leave": "ອອກບໍ່?",
  "call.mic_on": "ເປີດໄມ",
  "call.muted_label": "ປິດໄມ",
  "call.camera_off": "ປິດກ້ອງ",
  "call.connect_failed": "ເຊື່ອມຕໍ່ບໍ່ໄດ້ — ເຊັກເນັດແລ້ວລອງໃໝ່ເດີ້.",
  "call.camera_access_failed": "ເຂົ້າເຖິງກ້ອງບໍ່ໄດ້. ເຊັກສິດໃນບຣາວເຊີແລ້ວລອງໃໝ່.",
  "call.recording_failed": "ອັດວິດີໂອບໍ່ໄດ້. ສາຍຈະດຳເນີນຕໍ່ໄປແບບບໍ່ອັດ.",
  "call.initialize_failed": "ມີບາງຢ່າງຜິດພາດຕອນເລີ່ມສາຍ. ຣີເຟຣຊແລ້ວລອງໃໝ່ເດີ້.",
  "call.participants": "ຜູ້ເຂົ້າຮ່ວມ",
  "call.open_participants": "ເປີດເບິ່ງຜູ້ເຂົ້າຮ່ວມ",
  "call.close_participants": "ປິດຜູ້ເຂົ້າຮ່ວມ",
  "call.lock_room": "ລັອກຫ້ອງ",
  "call.unlock_room": "ປົດລັອກຫ້ອງ",
  "call.locked": "ລັອກແລ້ວ",
  "call.unlocked": "ເປີດແລ້ວ",
  "call.kick_member": "ເຕະອອກຈາກຫ້ອງ",
  "call.mute_member": "ປິດໄມ",
  "call.unmute_member": "ເປີດໄມ",
  "call.muted_by_host": "ເຈົ້າຂອງຫ້ອງປິດໄມ",
  "call.waiting_to_join": "ລໍຖ້າເຂົ້າຫ້ອງ",
  "call.approve": "ຮັບເຂົ້າ",
  "call.deny": "ປະຕິເສດ",
  "call.profile_actions": "ຈັດການໂປຣໄຟລ໌",
  "call.profile_in_room": "ໃນຫ້ອງ",
  "call.profile_role_host": "ເຈົ້າຂອງຫ້ອງ",
  "call.profile_role_you": "ເຈົ້າ",
  "call.profile_action_mute": "ປິດສຽງເຂົາເຈົ້າ",
  "call.profile_action_mute_meta": "ສະເພາະເຈົ້າ — ເຂົາເຈົ້າຈະບໍ່ຮູ້",
  "call.profile_action_dm": "ທັກສ່ວນຕົວ",
  "call.profile_action_dm_meta": "ເລີ່ມແຊັດສ່ວນຕົວກັບຄົນນີ້",
  "call.profile_action_view": "ເບິ່ງໂປຣໄຟລ໌ເຕັມ",
  "call.profile_action_view_meta": "ປະຫວັດ, ພາສາ, ຫ້ອງທີ່ເຄີຍເຂົ້າ",
  "call.profile_action_report": "ລາຍງານ",
  "call.profile_action_report_meta": "ແຈ້ງໃຫ້ແອດມິນກວດສອບ",
  "call.profile_sheet_close": "ປິດການຈັດການໂປຣໄຟລ໌",
  "call.profile_open_actions": "ເປີດການຈັດການໂປຣໄຟລ໌",
  "call.dm_title": "ຂໍ້ຄວາມສ່ວນຕົວ",
  "call.dm_back": "ກັບຄືນ",
  "call.dm_close": "ປິດຂໍ້ຄວາມສ່ວນຕົວ",
  "call.dm_status_online": "ອອນລາຍ",
  "call.dm_in_room_with": "ໃນຫ້ອງນີ້",
  "call.dm_private_label": "ແຊັດສ່ວນຕົວ",
  "call.dm_private_meta": "ມີແຕ່ພວກເຈົ້າສອງຄົນທີ່ເຫັນຂໍ້ຄວາມນີ້",
  "call.dm_input_placeholder": "ສົ່ງຂໍ້ຄວາມສ່ວນຕົວ…",
  "call.dm_send": "ສົ່ງ",
  "call.dm_just_now": "ຕອນນີ້",
  "call.dm_seen_just_now": "ອ່ານເມື່ອກີ້",
  "call.dm_typing": "{name} ກຳລັງພິມ…",
  "call.dm_minimize": "ຫຍໍ້ລົງ",
  "call.dm_active_indicator": "ເປີດແຊັດ",
  "call.dm_unread_messages": "ຍັງບໍ່ໄດ້ອ່ານ {count} ຂໍ້ຄວາມ",
  "call.dm_toast_tap_to_open": "ກົດເພື່ອເປີດ",
  "call.dm_reopen_aria": "ເປີດແຊັດກັບ {name} ອີກຄັ້ງ",
  "home.join_denied": "ເຈົ້າຂອງຫ້ອງບໍ່ໃຫ້ເຂົ້າ.",
  "home.error.room_not_found": "ບໍ່ມີລະຫັດຫ້ອງນີ້.",
  "home.error.profile_required": "ຕັ້ງຄ່າໂປຣໄຟລ໌ກ່ອນໄປຕໍ່.",
  "home.cta.set_up_profile": "ຕັ້ງຄ່າໂປຣໄຟລ໌",
  "home.profile_trigger_new": "ກົດເພື່ອເພີ່ມຂໍ້ມູນຂອງເຈົ້າ",
  "home.profile_trigger_new_aria": "ຕັ້ງຄ່າໂປຣໄຟລ໌",
  "home.profile_trigger_edit_aria": "ແກ້ໄຂໂປຣໄຟລ໌",
  "profile.eyebrow_new": "ທັກທາຍ",
  "profile.eyebrow_edit": "ໂປຣໄຟລ໌ຂອງເຈົ້າ",
  "profile.title_new": "ສ້າງສະຕາຍຂອງເຈົ້າ.",
  "profile.title_edit": "ແກ້ໄຂໂປຣໄຟລ໌",
  "profile.subtitle": "ໃສ່ຂໍ້ມູນຈັກໜ້ອຍ ໃຫ້ໝູ່ຮູ້ວ່າກຳລັງລົມກັບໃຜ.",
  "profile.add_photo": "ເພີ່ມຮູບ",
  "profile.add_photo_soon": "ລະບົບຮູບພາບກຳລັງມາ",
  "profile.photo_empty": "ກົດເພື່ອເພີ່ມຮູບ",
  "profile.photo_ready": "ຮູບພ້ອມແລ້ວ",
  "profile.photo_save_first": "ເຊບໂປຣໄຟລ໌ກ່ອນອັບໂຫຼດຮູບເດີ້",
  "profile.photo_crop_caption": "ຈັດເຟຣມຮູບ",
  "profile.photo_auto_caption": "ລາກແລ້ວຊູມເລີຍ, ດຽວລະບົບເຊບໃຫ້ອັດຕະໂນມັດ",
  "profile.photo_upload": "ອັບໂຫຼດຮູບ",
  "profile.photo_replace": "ປ່ຽນຮູບ",
  "profile.photo_remove": "ລຶບຮູບ",
  "profile.photo_cancel": "ຍົກເລີກ",
  "profile.photo_save": "ເຊບຮູບ",
  "profile.photo_uploading": "ກຳລັງອັບໂຫຼດຮູບ…",
  "profile.photo_removing": "ກຳລັງລຶບຮູບ…",
  "profile.photo_choose_another": "ເລືອກຮູບໃໝ່",
  "profile.photo_drag_hint": "ລາກຮູບໃຫ້ພໍດີກັບວົງມົນ. ລະບົບຈະເຊບໃຫ້ອັດຕະໂນມັດ.",
  "profile.photo_zoom": "ຊູມ",
  "profile.photo_horizontal": "ຕັດລວງນອນ",
  "profile.photo_vertical": "ຕັດລວງຕັ້ງ",
  "profile.name_label": "ຊື່",
  "profile.name_placeholder": "ໃຫ້ພວກເຮົາເອີ້ນເຈົ້າວ່າຫຍັງ?",
  "profile.gender_label": "ຂ້ອຍແມ່ນ",
  "profile.gender.woman": "ຜູ້ຍິງ",
  "profile.gender.man": "ຜູ້ຊາຍ",
  "profile.gender.unspecified": "ບໍ່ຂໍບອກ",
  "profile.bio_label": "ແນະນຳຕົວ",
  "profile.bio_optional": "ໃສ່ກໍໄດ້ບໍ່ໃສ່ກໍໄດ້",
  "profile.bio_placeholder": "ພາສາທີ່ເວົ້າ, ສິ່ງທີ່ມັກ, ຫຼື ຫຍັງກໍໄດ້…",
  "profile.cta_new": "ລຸຍເລີຍ",
  "profile.cta_edit": "ເຊບ",
  "profile.saving": "ກຳລັງເຊບ…",
  "profile.close": "ປິດ",
  "profile.error.save_failed": "ເຊບໂປຣໄຟລ໌ບໍ່ໄດ້. ລອງໃໝ່ເດີ້.",
  "profile.error.avatar_invalid_type": "ເລືອກຮູບ PNG, JPEG, GIF, ຫຼື WebP ເດີ້.",
  "profile.error.avatar_too_large": "ເລືອກຮູບຂະໜາດນ້ອຍກວ່າ 5 MB ເດີ້.",
  "profile.error.avatar_too_small": "ເລືອກຮູບຂະໜາດຢ່າງໜ້ອຍ 96x96 ພິກເຊວເດີ້.",
  "profile.error.avatar_load_failed": "ອ່ານຮູບບໍ່ໄດ້. ລອງໄຟລ໌ອື່ນເບິ່ງ.",
  "profile.error.avatar_failed": "ອັບໂຫຼດຮູບບໍ່ໄດ້. ລອງໃໝ່ເດີ້.",
  "profile.error.avatar_remove_failed": "ລຶບຮູບບໍ່ໄດ້. ລອງໃໝ່ເດີ້.",
  "effects.title": "ເອັບເຟັກ",
  "effects.soft": "ໂຟກັສຊອບໆ",
  "effects.vignette": "ຂອບມືດ",
  "effects.face": "ເບຼີໜ້າ",
  "effects.face_preview_only": "ເບຼີໜ້າ (ສະເພາະພຣີວິວ)",
  "effects.face_viewer_side": "ເບຼີໜ້າ (ຝັ່ງຄົນເບິ່ງ)",
  "effects.face_strength": "ລະດັບຄວາມເບຼີ",
  "effects.grade.off": "ປິດ",
  "effects.grade.pop": "ປັອບ",
  "effects.grade.warm": "ອຸ່ນ",
  "effects.grade.cool": "ເຢັນ",
  "effects.grade.bw": "B&W",
  "camera.off": "ປິດກ້ອງຢູ່",
  "camera.check": "ເຊັກກ້ອງແປັບ",
  "camera.retry": "ລອງເປີດກ້ອງໃໝ່",
  "camera.ready": "ກ້ອງພ້ອມແລ້ວ",
  "camera.idle.title": "ເປີດກ້ອງເລີຍ",
  "camera.idle.hint": "ດຽວເຮົາຈະຂໍສິດເຂົ້າເຖິງກ້ອງເມື່ອເຈົ້າພ້ອມ.",
  "camera.idle.button": "ເປີດກ້ອງ",
  "camera.status.idle": "ລໍຖ້າເຈົ້າຢູ່",
  "camera.status.off": "ປິດກ້ອງຢູ່",
  "camera.status.loading": "ກຳລັງຂໍສິດເຂົ້າເຖິງກ້ອງ...",
  "camera.status.denied": "ອະນຸຍາດໃຫ້ບຣາວເຊີເຂົ້າເຖິງກ້ອງກ່ອນ, ແລ້ວລອງໃໝ່.",
  "camera.status.error": "ພຣີວິວກ້ອງບໍ່ໄດ້. ລອງໃໝ່ເດີ້.",
  "camera.status.unsupported": "ບຣາວເຊີນີ້ບໍ່ຮອງຮັບການເຂົ້າເຖິງກ້ອງ.",
  "camera.status.insecure": "ການເຂົ້າເຖິງກ້ອງຕ້ອງໃຊ້ HTTPS ຫຼື localhost.",
  "camera.status.attach_failed": "ເລີ່ມພຣີວິວກ້ອງບໍ່ໄດ້. ລອງໃໝ່ເດີ້.",
  "camera.guest_name_placeholder": "ຊື່ແຂກ",
  "camera.flip": "ສະຫຼັບກ້ອງ",
  "camera.save_name": "ເຊບ",
  "camera.edit_name": "ປ່ຽນຊື່",
  "mic.on": "ປິດໄມ",
  "mic.off": "ເປີດໄມ",
  "video.on": "ປິດກ້ອງ",
  "video.off": "ເປີດກ້ອງ",
  "chat.title": "ແຊັດ",
  "chat.close": "ປິດແຊັດ",
  "chat.loading": "ກຳລັງໂຫຼດ...",
  "chat.load_earlier": "ໂຫຼດຂໍ້ຄວາມກ່ອນໜ້າ",
  "chat.empty": "ຍັງບໍ່ມີຂໍ້ຄວາມ",
  "chat.send_error": "ສົ່ງຂໍ້ຄວາມບໍ່ໄດ້ — ລອງໃໝ່ເດີ້.",
  "chat.input_placeholder": "ພິມຂໍ້ຄວາມ...",
  "room.host": "ເຈົ້າຂອງຫ້ອງ",
  "app.room_default_title": "ສ້າງຫ້ອງ",
  "app.chat_connection_rejected": "ເຊື່ອມຕໍ່ແຊັດບໍ່ໄດ້ — ລອງຣີເຟຣຊເບິ່ງເດີ້.",
  "app.copy_failed": "ກັອບປີ້ລິ້ງບໍ່ໄດ້. ລອງເລືອກແລ້ວກັອບປີ້ເອງເດີ້.",
  "app.chat_not_connected": "ແຊັດຍັງບໍ່ເຊື່ອມຕໍ່. ລໍຖ້າແປັບໜຶ່ງແລ້ວລອງໃໝ່.",
  "footer.terms": "ເງື່ອນໄຂການໃຊ້ງານ",
  "footer.copyright": "© 2026 Yano.AI"
}
